function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "07B02247-F7BE-4502-AB21-615E4DCEC31C");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-490.000000, -6556.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Mint",
  transform: "translate(490.000000, 6556.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 60,
  height: 60
}), /*#__PURE__*/React.createElement("g", {
  id: "Mint-assets-Icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,60 C46.5705013,60 60,46.5704978 60,30 C60,13.4324804 46.5705013,0 30,0 C13.4325001,0 0,13.4324804 0,30 C0,46.5704978 13.4325001,60 30,60 L30,60 Z",
  id: "Oval_49_",
  fill: "#1D4C56"
}), /*#__PURE__*/React.createElement("g", {
  id: "Shape",
  transform: "translate(8.845505, 23.362427)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.9460032,0 C38.2755051,0 3.5565007,0 3.36300114,0 C1.50599967,0 0,1.51199341 0,3.36300659 L0,28.5795124 C0,30.2205041 1.2135001,31.7355178 2.83049869,31.9950256 L39.4769972,31.9950256 C41.096999,31.7340074 42.3104954,30.2190395 42.3104954,28.5795124 C42.3104954,27.7380066 42.3104954,4.12500002 42.3104954,3.36300659 C42.3090049,1.51052856 40.8000021,0 38.9460032,0 L38.9460032,0 Z",
  stroke: "#1D9682",
  strokeWidth: 1.5,
  fill: "#1D9682"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5600014,28.5839989 C40.5600014,29.5769795 39.7484992,30.388504 38.7555011,30.388504 L3.5505037,30.388504 C2.55750272,30.388504 1.74600506,29.5770257 1.74600506,28.5839989 L1.74600506,3.52349842 C1.74600506,2.53051756 2.55750561,1.71899414 3.5505037,1.71899414 L38.7555011,1.71899414 C39.7484992,1.71899414 40.5600014,2.53047179 40.5600014,3.52349842 L40.5600014,28.5839989 L40.5600014,28.5839989 Z",
  fill: "#1D716C"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.827026, 7.385193)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1999989,3.29173271 C14.8124997,-1.09725957 7.67549771,-1.09725957 3.28949844,3.29173271 C-1.09650132,7.6777496 -1.09650132,14.8147438 3.28949844,19.2022246 C7.67699703,23.5882428 14.8139983,23.5882428 19.1999989,19.2022246 C23.5859982,14.8132329 23.5859982,7.6762394 19.1999989,3.29173271 L19.1999989,3.29173271 Z",
  id: "Shape",
  stroke: "#1DCDA2",
  strokeWidth: 1.5,
  fill: "#1DCDA2"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.796997, 1.797729)",
  fill: "#1DA88D",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.44849968,
  cy: 9.44849968,
  r: 9.44849968
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.191778, 8.196533)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.440717688,9.90769974 C0.0747184719,9.54171753 -0.0917816144,8.99720754 0.0507173542,8.46020526 C0.265216826,7.6576997 1.08721733,7.18222076 1.88821781,7.39668269 C3.43771916,7.80917346 5.10421921,7.36518892 6.23521913,6.23419192 C7.36621841,5.1001741 7.81321891,3.43670666 7.39771837,1.88717648 C7.18471779,1.08769228 7.65871815,0.267196667 8.46121766,0.0526886 C9.25921961,-0.164794926 10.0812205,0.310684217 10.2972163,1.1131897 C10.9872144,3.69470223 10.2432172,6.46820079 8.35621845,8.35519417 C6.46921905,10.2421875 3.69421855,10.9832156 1.11421964,10.2946931 C0.850218722,10.2241978 0.622218117,10.0892031 0.440717688,9.90769974 L0.440717688,9.90769974 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.748117, 3.750412)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.639378525,10.1058194 C0.45937729,9.92431572 0.322877869,9.69630412 0.2523794,9.43231152 C-0.43612,6.85382054 0.307880388,4.08032222 2.19338029,2.19332879 C4.06987945,0.318328841 6.8313789,-0.428649905 9.40088026,0.241836532 C10.2033801,0.453323339 10.6803816,1.27381892 10.4718817,2.07334894 C10.2603805,2.87585435 9.44138138,3.3558652 8.64038032,3.14584346 C7.09987988,2.74085995 5.44088172,3.18933102 4.31588144,4.31735202 C3.18488212,5.44834849 2.73638238,7.1118622 3.15038098,8.65983553 C3.36488057,9.45931958 2.88938124,10.2828362 2.08838081,10.4973447 C1.55137823,10.638336 1.00537772,10.4718474 0.639378525,10.1058194 L0.639378525,10.1058194 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.993998, 8.993225)",
  fill: "#1DCDA2",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.25150007,
  cy: 2.25150007,
  r: 2.25150007
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(22.019989, 16.833801)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1999989,3.29173271 C14.811001,-1.09725957 7.67399905,-1.09725957 3.28949844,3.29173271 C-1.09650132,7.6777496 -1.09650132,14.8147438 3.28949844,19.2022246 C7.67549771,23.5882428 14.8124997,23.5882428 19.1999989,19.2022246 C23.5859982,14.8147438 23.5859982,7.6777496 19.1999989,3.29173271 L19.1999989,3.29173271 Z",
  id: "Shape",
  stroke: "#1DCDA2",
  strokeWidth: 1.5,
  fill: "#1DCDA2"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.795498, 1.799194)",
  fill: "#1DA88D",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.44849968,
  cy: 9.44849968,
  r: 9.44849968
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.191784, 8.196533)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.440717721,9.90769974 C0.0747184774,9.54171753 -0.09178162,8.99720754 0.0507202177,8.46020526 C0.265222548,7.6576997 1.08722305,7.18222076 1.88821803,7.39668269 C3.43771942,7.80917346 5.10272039,7.36518892 6.23521641,6.23419192 C7.36621868,5.1001741 7.81171431,3.43670666 7.39771861,1.88717648 C7.18321615,1.08769228 7.65871826,0.267196667 8.46121807,0.0526886 C9.2577152,-0.164794926 10.0812206,0.310684217 10.2957174,1.1131897 C10.9872148,3.69470223 10.2432175,6.46820079 8.35621832,8.35519417 C6.46921909,10.2421875 3.69271671,10.9832156 1.11421971,10.2946931 C0.848716791,10.2241978 0.622215299,10.0892031 0.440717721,9.90769974 L0.440717721,9.90769974 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.748100, 3.750412)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.639398548,10.1058199 C0.457898134,9.92431676 0.322897907,9.69630423 0.252399426,9.43231183 C-0.436099981,6.8538206 0.307900412,4.08032233 2.19189832,2.19332884 C4.06989955,0.318328864 6.82989656,-0.428649924 9.39939827,0.241836542 C10.2018984,0.453323375 10.6803985,1.27381897 10.4718984,2.07334898 C10.2604003,2.8758544 9.43989906,3.35586562 8.64039762,3.14584366 C7.09989721,2.74085993 5.44089878,3.18933116 4.31589859,4.3173523 C3.18489909,5.44834909 2.73639956,7.11186235 3.15039824,8.65983564 C3.36489764,9.45932015 2.88939842,10.2828367 2.08689875,10.4973448 C1.55139818,10.6398013 1.00539774,10.471802 0.639398548,10.1058199 L0.639398548,10.1058199 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.992498, 8.994736)",
  fill: "#1DCDA2",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.25150007,
  cy: 2.25150007,
  r: 2.25150007
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.755997, 28.112274)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1999989,3.29173304 C14.811001,-1.09725954 7.67399905,-1.09725954 3.28949844,3.29173304 C-1.09650132,7.67774981 -1.09650132,14.8147444 3.28949844,19.2022262 C7.67549771,23.5882426 14.8124997,23.5882426 19.1999989,19.2022262 C23.5859982,14.8146975 23.5859982,7.67770422 19.1999989,3.29173304 L19.1999989,3.29173304 Z",
  id: "Shape",
  stroke: "#1DCDA2",
  strokeWidth: 1.5,
  fill: "#1DCDA2"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.796997, 1.799194)",
  fill: "#1DA88D",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.44849968,
  cy: 9.44849968,
  r: 9.44849968
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.191781, 8.196533)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.440717683,9.90769974 C0.0747184731,9.54171753 -0.0917816154,8.99720754 0.0507173527,8.46020526 C0.265216823,7.6576997 1.0872173,7.18222076 1.88821791,7.39668269 C3.43771627,7.80917346 5.10271737,7.36518892 6.23521873,6.23419192 C7.36622131,5.1001741 7.81171705,3.43670666 7.39772124,1.88717648 C7.18321873,1.08769228 7.65872097,0.267196667 8.46122037,0.0526886 C9.25771771,-0.164794926 10.0812234,0.310684217 10.2957196,1.1131897 C10.9872178,3.69470223 10.2432203,6.46820079 8.35622122,8.35519417 C6.46922211,10.2421875 3.69271929,10.9832156 1.11422253,10.2946931 C0.848716707,10.2241978 0.623717278,10.0891572 0.440717683,9.90769974 L0.440717683,9.90769974 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.748097, 3.750412)",
  fill: "#1DEBB4",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.639398571,10.1058201 C0.457898127,9.92431666 0.322897918,9.69630478 0.252399455,9.43231207 C-0.43610002,6.85382097 0.307900427,4.08032243 2.19189835,2.19332885 C4.06989969,0.318328854 6.82989972,-0.42864993 9.39939572,0.241836543 C10.2018957,0.453323375 10.6803956,1.27381898 10.4718962,2.07334906 C10.2603981,2.87585444 9.43989649,3.35586541 8.64039527,3.14584364 C7.09989465,2.74086 5.44089605,3.189331 4.31589616,4.31735246 C3.18489635,5.44834936 2.73639694,7.11186214 3.1503955,8.6598363 C3.36489485,9.45932001 2.88939576,10.2828368 2.08689598,10.4973451 C1.55140121,10.638291 1.00689988,10.4718019 0.639398571,10.1058201 L0.639398571,10.1058201 Z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.993998, 8.994690)",
  fill: "#1DCDA2",
  id: "Circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.25150007,
  cy: 2.25150007,
  r: 2.25150007
})))))));

var SvgIconMint = function SvgIconMint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Mint.8590b0eb.svg";
export { ForwardRef as ReactComponent };